'use strict';

/* jshint -W098 */
angular.module('mean.system-bids').controller('ModalRefreshController', ['$scope', 'Global', '$uibModalInstance', 'trade', 'selectedBid', 'toaster', 'projectBidService', 'Projects',
  function($scope, Global, $uibModalInstance, trade, selectedBid, toaster, projectBidService, Projects) {
    $scope.global = Global;
    $scope.package = {
      name: 'system-bids'
    };

    console.log('ModalRefreshController');

    $scope.trade = trade;
    $scope.selectedBid = selectedBid;

    $scope.updateDates = function(item) {
        if(item.date_received)
            item.date_received = new Date(item.date_received);
        if(item.date_requested)
            item.date_requested = new Date(item.date_requested);
        if(item.date_declined)
            item.date_declined = new Date(item.date_declined);
        if(item.date_rejected)
            item.date_rejected = new Date(item.date_rejected);
        if(item.date_accepted)
            item.date_accepted = new Date(item.date_accepted);
        if(item.date_completed)
            item.date_completed = new Date(item.date_completed);
    };

    $scope.removeDates = function(item) {
        if(!item.date_received || item.date_received == 'Invalid Date')
            delete item.date_received;
        if(!item.date_requested || item.date_requested == 'Invalid Date')
            delete item.date_requested;
        if(!item.date_declined || item.date_declined == 'Invalid Date')
            delete item.date_declined;
        if(!item.date_rejected || item.date_rejected == 'Invalid Date')
            delete item.date_rejected;
        if(!item.date_accepted || item.date_accepted == 'Invalid Date')
            delete item.date_accepted;
        if(!item.date_completed || item.date_completed == 'Invalid Date')
            delete item.date_completed;
    };

    $scope.ok = function () {
        $uibModalInstance.close();
    };

    $scope.regenerateBidData = function() {
        // var idx = $scope.selectedBid.bidding_trades.indexOf($scope.trade);
        // $scope.removeDates($scope.trade);
        // $scope.trade.$update(function(success) {
        //     $scope.updateDates(success);
        //     $scope.selectedBid.bidding_trades[idx] = success;
        //     $uibModalInstance.close();
        //     toaster.pop('success', 'Trade Updated');
        // }, function(error) {
        //     //$scope.selectedBid.bidding_trades[idx] = $scope.backuptrade;
        //     toaster.pop('error', 'Trade DB Error', error);
        // });

        //if(!$scope.is_admin) return;
        console.log('in regenerateBidData');

        Projects.query({'name': $scope.selectedBid.project_name}, function(projects) {
            if(projects.length !== 1) {
                toaster.pop('error', 'Project Information', 
                    'Could not get the project.  Contact Admin.');
                return;
            }

            var view_obj = {
                bid_general_liability: 0,
                bid_total_labor: 0,
                bid_total_materials: 0,
                bid_materials_taxes: 0,
                bid_materials_subtotal: 0,
                bid_total_equipment: 0,
                bid_equipment_subtotal: 0,
                bid_equipment_taxes: 0,
                bid_direct_labor: 0,
                bid_mark_up: 0,
                bid_workers_comp: 0,
                bid_payroll_taxes: 0,
                bid_overhead_and_profit: 0,
                bid_total: 0
            }

            projectBidService.buildProjectBidsFromPlans(
                projects[0]._id, 
                $scope.trade, 
                projects[0].plan_codes,
                view_obj);
        });
    };

    $scope.savePlanTotalsToProject = function() {
        console.log('this function does nothing at this point');
        // if(!$scope.is_admin) return;
        // console.log('in savePlanTotalsToProject');

        // Projects.query({'name': $scope.bid.project_name}, function(projects) {
        //     if(projects.length !== 1) {
        //         toaster.pop('error', 'Project Information', 
        //             'Could not get the project.  Contact Admin.');
        //         return;
        //     }

        //     var project = projects[0];

        //     //this is to fix project revisions and should be taken 
        //     //out after fixing up the bad projects.
        //     // _.each(project.trades[0].revisions, function(rev, itr) {
        //     //     rev.number = itr + 1;
        //     // });
            
        //     _.each($scope.revisions, function(rev) {
        //         $scope.selectedRevision = rev;
        //         $scope.changeRevision(); //update new revision totals
        //         _.each($scope.totals, function(total) {
        //             var item = $filter('filter')(project.plan_codes, {'item': total.plan}, true);

        //             if(item.length !== 1) {
        //                 toaster.pop('error', 'Error Finding Plan Code', 'Contact Admin');
        //                 return;
        //             }

        //             _.remove(item[0].trade_totals, function(total) {
        //                 return total.revision === 0;
        //             });

        //             var revision = rev.revision;

        //             var trade_details = $filter('filter')(item[0].trade_totals, {
        //                 'trade': $scope.user.trade[0], 'revision': revision }, true);

        //             if(trade_details.length === 0) {
        //                 item[0].trade_totals.push({ 
        //                     trade: total.trade,
        //                     total: total.total,
        //                     revision: revision
        //                 });
        //             } else if(trade_details.length === 1) {
        //                 trade_details[0].total = total.total;
        //             } else {
        //                 //too many trade totals for this revision, 
        //                 //remove all and set to one.
        //                 var rmv = _.remove(item[0].trade_totals, function(item) {
        //                     return item.trade === $scope.user.trade[0] &&
        //                         item.revision === revision;
        //                 });

        //                 item[0].trade_totals.push({ 
        //                     trade: total.trade,
        //                     total: total.total,
        //                     revision: revision
        //                 });
        //             }
        //             item[0].total = total.total;
        //         });
        //     });

        //     //console.log(project);
        //     project.$update(function(success) {
        //         toaster.pop('success', 'Project Database Updated');
        //     }, function(error) {
        //         toaster.pop('error', 'Project Update Error', error);
        //     });
        // });
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/system-bids/public/controllers/modal-refresh-controller.js